import React, { FC, useEffect, useState } from 'react';
import { Container } from '../../components/container/container';
import { IDepartment, ISection } from '../../apis/department';
import { Catalog } from '../../apis/search-catalog';
import { isValidUrl } from '../../util/url';
import { PageBanner } from '../../components/page-banner/page-banner';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ServiceCarousel } from '../../components/carousel/service-carousel';

export interface DepartmentProps extends IDepartment {
  section?: ISection[];
  catalogList?: Catalog[];
  onClickCatalog: (slug: string, categorySlug: string) => void;
  currentPage?: number;
  resultTotal?: number;
  onPaginate?: (page: number) => void;
  departmentServicesRef?: React.Ref<HTMLDivElement>;
}

export const Department: FC<DepartmentProps> = ({
  name,
  shortName,
  description,
  slug,
  section,
  catalogList,
  onClickCatalog,
  link,
  currentPage,
  resultTotal,
  onPaginate,
  departmentServicesRef,
}) => {
  const [session, setSession] = useState<any>();

  useEffect(() => {
    if (section && section[0]) {
      setSession(section[0]);
    }
  }, [section]);

  return (
    <div className={styles.department}>
      <Container>
        <PageBanner title={shortName} />

        <div className={styles.mainContent}>
          <div className={styles.contentWrapper}>
            <div className={styles.headerContent}>
              <div className={styles.titleGroup}>
                <h2 className={styles.subtitle}>{name}</h2>
              </div>

              <div className={styles.descriptionSection}>
                <p
                  className={styles.description}
                  dangerouslySetInnerHTML={{
                    __html: description || 'Descrição não informada',
                  }}
                />
              </div>

              {session && (
                <div className={styles.scheduleSection}>
                  <h4 className={styles.scheduleTitle}>
                    Horário de atendimento ao público:
                  </h4>
                  <p className={styles.scheduleText}>{session.openingTime}</p>
                </div>
              )}
            </div>
          </div>

          <div className={styles.sideContent}>
            {isValidUrl(link) && (
              <button
                className={styles.actionButton}
                onClick={() => window.open(link, '_blank')}
              >
                <FontAwesomeIcon icon="edit" />
                <span>Acessar Website Oficial</span>
              </button>
            )}

            {!!session && (
              <div className={styles.contactCard}>
                {!!session.openingTime && (
                  <div className={styles.contactItem}>
                    <h3 className={styles.contactTitle}>
                      Horário de atendimento
                    </h3>
                    <p className={styles.contactText}>{session.openingTime}</p>
                  </div>
                )}

                <div className={styles.contactItem}>
                  <h3 className={styles.contactTitle}>Localização</h3>
                  <p className={styles.contactText}>
                    {session.address}
                    <br />
                    {!!session.complement && (
                      <>
                        {session.complement}
                        <br />
                      </>
                    )}
                    {session.district && `${session.district} - `}
                    {session.city}/{session.state}
                    <br />
                    CEP: {session.postalCode}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>

        {!!catalogList?.length && (
          <div ref={departmentServicesRef}>
            <ServiceCarousel
              items={catalogList}
              onClickCatalog={onClickCatalog}
            />
          </div>
        )}
      </Container>
    </div>
  );
};
